import styled from 'styled-components';
import Icon from 'components/Icon';

const Container = styled.div`
	padding: 16px 0 0;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

const PositionContainer = styled.div`
	width: 100%;
	padding-bottom: 100%;
	background-color: #FAFAFA;
	box-shadow: 0px 2px 4px 2px #DFDFDF inset;
	border-radius: 4px;
	position: relative;
	overflow: hidden;
`;

const HandleWrapper = styled.div`
	width: calc(100% - 2px);
	height: calc(100% - 2px);
	position: absolute;
	top: 1px;
	left: 1px;
`;

const Handle = styled.div`
	width: 48px;
	height: 48px;
	background-color: white;
	border-radius: 4px;
	position: relative;
	box-shadow: 0px 4px 16px -6px #9B9B9B, 0px 4px 8px -4px #9B9B9B;
	cursor: move;
	cursor: grab;
	cursor: -moz-grab;
	cursor: -webkit-grab;

	&:active {
    cursor: grabbing;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
	}
`;

const GrabIcon = styled(Icon)`
	display: inline-block;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-30%, -50%);

	&:nth-child(1) {
		transform: translate(-70%, -50%);
	}

	svg {
		fill: ${params => params.theme.main};
	}
`;

export {
	Container,
	Label,
	PositionContainer,
	HandleWrapper,
	Handle,
	GrabIcon,
}
